import { of } from 'rxjs';
import { CustomAsyncValidatorFn } from '@shared/form-elements/model/form-elements.model';
import { map, take } from 'rxjs/operators';
import { StoresService } from '@features/stores-overview/service/stores.service';

export const storesValidator =
    (storesService: StoresService): CustomAsyncValidatorFn =>
    control => {
        const storeId = control.value;

        if (!storeId) {
            // Does not check for 'required', use separate validator
            return of(null);
        }

        return storesService.getStoreById(storeId).pipe(
            take(1),
            map(response => (response ? null : { invalidStore: true as const }))
        );
    };
